import {UTCDate} from "@date-fns/utc";
import classNames from "classnames";
import {differenceInSeconds} from "date-fns";

import {KPICard} from "@/components/KPICard/KPICard.tsx";
import {PENDING_STATE_SECONDS} from "@/pages/checks/analysis/utils.ts";
import {State} from "@/pages/checks/constants.ts";

interface StatHeaderCurrentStatusProps {
  createdAt: string;
  isUnderMaintenance: boolean;
  state: State;
}

export const StatHeaderCurrentStatus = ({createdAt, isUnderMaintenance, state}: StatHeaderCurrentStatusProps) => {
  let currentState = state;

  if (differenceInSeconds(new UTCDate(), createdAt) < PENDING_STATE_SECONDS) {
    currentState = State.Pending;
  }

  return (
    <KPICard title="Current Status">
      <span
        className={classNames({
          "check-status-up": state === State.Up && !isUnderMaintenance,
          "check-status-down": state === State.Down && !isUnderMaintenance,
          "check-status-maintenance": isUnderMaintenance,
        })}
      >
        {!isUnderMaintenance ? currentState : "In Maintenance"}
      </span>
    </KPICard>
  );
};
